// extracted by mini-css-extract-plugin
export default {"container":"oUaQF","icon":"wWRWG","invert":"PjaGG"};